import { TextContent } from '../text-content';


export class Note {
  id: number;
  active: boolean;
  ownerId: number;
  isOpen?: boolean;
  content?: string;
  parentId?: number;
  textContent: TextContent;
  isOverview?: boolean;

  constructor (data: any = {}) {
    this.id = data.id || null;
    this.isOverview = false;
    this.active = data.active || null;
    this.ownerId = data.ownerId || null;
    this.textContent = data.textContent || null;
  }
}
